module.exports = __webpack_public_path__ + "99d0ea1367fb159b68dc843c47efdb43.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/poster-gloss.png
// module id = 849
// module chunks = 0